import { makeStyles, Theme } from "@material-ui/core/styles";


export const headerStyles = makeStyles({
    headerContainer: {
        borderBottom: '1px solid #c4c4c4',
        marginBottom: '10px',
        paddingBottom: '10px'
    },
    button: {
        boxShadow: 'none',
        margin: '5px'
    },
});

export const styles = makeStyles((theme: Theme) => ({
    wrapper: {
        paddingTop: '20px',
        margin: '0 auto',
        width: '92%',
        [theme.breakpoints.up('md')]: {
            width: '80%',
        },
    },
    fullWidth: {
        width: '100%',
    },
    block: {
        marginTop: '15px',
        marginBottom: '15px'
    },
    col: {
        width: '92%'
    },
    flex: {
        display: 'flex'
    },
    flexRow: {
        flexDirection: 'row'
    },
    justifySpaceBetween: {
        justifyContent: 'space-between'
    },
    alignCenter: {
        alignItems: 'center'
    },
    mainContainer: {
        paddingRight: '16px',
        paddingLeft: '16px'
    },
    warning: {
        backgroundColor: '#F9D7D9',
        border: '1px solid #842129',
        borderRadius: '3px',
        color: '#842129',
        marginBottom: '10px',
        padding: '5px 15px'
    },
    restaurantInfoTop: {
        paddingBottom: '20px'
    },
    fakeLabel: {
        color: '#3e4345',
        fontSize: '0.75rem'
    },
    textRow: {
        margin: '10px 0 7px'
    },
    inputClean: {
        backgroundColor: 'transparent',
        '& .MuiInputLabel-shrink': {
            backgroundColor: 'transparent'
        }
    },
    listBox: {
        marginTop: '10px',
        overflow: 'hidden'
    },
    listBoxHead: {
        backgroundColor: '#808080',
        color: 'white',
        padding: '5px 15px 5px 10px'
    },
    listBoxHeadButton: {
        color: 'white'
    },
    listItem: {
        alignItems: 'baseline',
        paddingRight: '58px',
        paddingLeft: '10px'
    },
    divider: {
        margin: '30px 0 20px',
        position: 'relative'
    },
    dividerTitle: {
        backgroundColor: '#ffffff',
        padding: '0 3px',
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'translate(8px, -50%)'
    },
    switchControl: {
        color: '#757575',
        flexBasis: '48%',
        marginLeft: '0',
        marginRight: '0',
    },
    pictureContainer: {
        width: '100%'
    },
    picture: {
        display: 'block',
        width: '100%'
    }
}));
